import posthog from "posthog-js";

// Forwards the PostHog browser session id on every authenticated tRPC batch so
// server-side funnel events (submission_started, submission_screening_started,
// submission_screen_passed) can be linked to the matching session recording.
// PostHog's recommended pattern: read get_session_id() on the client and send
// it in a header; the server attaches it as $session_id. Skipped during SSR and
// before posthog-js has initialized a session.
export function getPostHogSessionHeader(): Record<string, string> {
  if (typeof window === "undefined") {
    return {};
  }
  try {
    const sessionId = posthog.get_session_id();
    return sessionId ? { "x-posthog-session-id": sessionId } : {};
  } catch {
    return {};
  }
}
